import { DEFAULT_PAGE_INFO } from '@apeiron/common'
import {
  deserializeListData,
  deserializePageInfo,
  PageInfo,
  PageInput,
  serializePagingInput
} from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { GuildType } from '@src/constants/guild'
import { guildSchema } from '@src/deserialize/yup/guild'
import graphql from '@src/graphql/query/getGuilds'
import { Guild } from '@src/types/guild'
import { useCallback, useState } from 'react'

const useGetGuilds = (): Hook => {
  const [fetchGuilds, { loading }] = useLazyQuery(graphql)

  const [data, setData] = useState<Guild[]>([])

  const [pageInfo, setPageInfo] = useState<PageInfo>(DEFAULT_PAGE_INFO)

  const fetch = useCallback(
    async (request: Request): Promise<Response> => {
      const { type, pageInput } = request

      const variables = {
        input: serializePagingInput(pageInput),
        type
      }

      const response = await fetchGuilds({ variables })

      const extraPath = ['guilds']

      const guilds = deserializeListData<Guild>(
        response,
        guildSchema,
        undefined,
        extraPath
      )

      const pageInfo = deserializePageInfo(response, pageInput)

      setData(guilds)

      setPageInfo(pageInfo)

      return {
        data: guilds,
        pageInfo
      }
    },
    [fetchGuilds]
  )

  return {
    data,
    loading,
    pageInfo,
    fetch
  }
}

type Request = {
  type: GuildType
  pageInput: PageInput
}

type Response = {
  data: Guild[]
  pageInfo: PageInfo
}

type Hook = {
  data: Guild[]
  loading: boolean
  pageInfo: PageInfo
  fetch: (request: Request) => Promise<Response>
}

export default useGetGuilds
